<template>
  <v-dialog v-model="show" fullscreen transition="dialog-top-transition">
    <div class="calendar_popup_wrap">
      <v-toolbar color="transparent" flat height="60" class="toolbar d-flex align-content-space-between">
        <button class="d-flex align-center" @click="$emit('close')">
          <i class="icon back"></i>
          나가기
        </button>
        <div class="date_picker_box d-flex align-center">
          구강촬영일시
          <span>|</span>
          <date-picker
            v-model="data.day"
            :allowed-dates="daily"
            custom="calendar"
            height="34"
            background-color="transparent"
            text-type="dot"
            :name="data.solInfo.name"
            @clickDate="clickDate"></date-picker>
        </div>
        <div class="d-flex justify-center fill-height">
          <router-link class="d-flex align-center px-1 mr-2" target="_blank" :to="{ name: 'NewPage', query: { id: data.solId, day: data.day } }"><i class="icon newwindow"></i></router-link>
          <button class="d-flex align-center px-1" @click="pdfDownload"><i class="icon pdf"></i></button>
        </div>
      </v-toolbar>
      <div class="d-flex justify-center report_wrap">
        <v-card width="1120">
          <div ref="pdfBlock">
            <h1>
              구강촬영경과
              <span>
                <span>
                  {{ data.solInfo.number }} {{ data.solInfo.name }}
                  <br />
                  구강촬영일시: {{ data.day ? $convertDateFormat('dot', data.day) : '' }}
                </span>
              </span>
            </h1>
            <div class="upper_report_wrap d-flex">
              <div class="summary_img_box">
                <img
                  :src="data.state ? require(`@/assets/img/report/img_${healthStatus[data.state].icon}.png`) : ''"
                  :alt="data.state ? `치아상태: ${healthStatus[data.state].text}` : ''"
                  width="320" />
                <div class="img_text_box">
                  <div v-html="data.state ? healthStatus[data.state].description : null"></div>
                  <div class="d-flex align-center">
                    <i class="icon recent"></i>
                    양치 촬영횟수
                  </div>
                  <div>총 {{ data.todayCount }}회</div>
                </div>
              </div>
              <div class="summary_chart_box">
                <status-bar-chart v-if="Object.keys(data.comparison).length !== 0" :key="data.day" :comparison="data.comparison" type="report" :name="`${data.solInfo.name} 용사님`"></status-bar-chart>
              </div>
            </div>
            <status-teeth :data="data.oralConditionList"></status-teeth>
            <div class="chart_divider mt-6"></div>
            <div class="down_report_wrap">
              <h2 class="d-flex align-center">
                <i class="icon education mr-3"></i>
                최근 일주일 구강상태
              </h2>
              <status-line-bar-chart v-if="data.daily.length !== 0" :key="data.day" :daily="data.daily" parent="report" class="mt-6"></status-line-bar-chart>
            </div>
          </div>
        </v-card>
      </div>
    </div>
  </v-dialog>
</template>

<script>
import DatePicker from '@/components/common/DatePicker';
import StatusBarChart from '@/components/status/StatusBarChart';
import StatusTeeth from '@/components/status/StatusTeeth';
import StatusLineBarChart from '@/components/status/StatusLineBarChart';
import { mapState } from 'vuex';
export default {
  name: 'UserReportPopup',
  components: {
    DatePicker,
    StatusBarChart,
    StatusTeeth,
    StatusLineBarChart,
  },
  props: {
    data: {
      type: Object,
      default: () => {
        return {
          solId: '',
          day: '',
          solInfo: {},
          state: '',
          todayCount: '',
          comparison: {},
          oralConditionList: [],
          dailyAverage: '',
          daily: [],
        };
      },
    },
    daily: {
      type: Array,
      default: null,
    },
    value: Boolean,
  },
  computed: {
    show: {
      get() {
        return this.value;
      },
      set(value) {
        this.$emit('input', value);
      },
    },
    ...mapState('commonValue', ['healthStatus']),
  },
  methods: {
    async pdfDownload() {
      const el = this.$refs.pdfBlock;
      // add option type to get the image version
      // if not provided the promise will return
      // the canvas.
      const options = {
        type: 'dataURL',
      };
      const output = await this.$html2canvas(el, options);

      const pageLink = 'about:blank';
      const pwa = window.open(pageLink, '_new');
      pwa.document.open();
      const source =
        `<html>
					<head>
						<style type="text/css" media="print">
							@page {
								margin-top: 0;
								margin-bottom: 0;
								margin-left: 10px;
								margin-right: 15px;
							}
						</style>
						<script>
							function step1() {
								setTimeout("step2()", 10);
							}
							function step2() {
								window.print();
								window.close();
							}
						</scr` +
        `ipt>
					</head>
					<body onload="step1()">
						<img src="${output}"/>
					</body>
					</html>`;

      pwa.document.write(source);
      pwa.document.close();
    },
    clickDate(val) {
      this.$emit('clickDate', val);
    },
  },
};
</script>

<style scoped></style>
